
import React from 'react';
import { Button } from '@/components/ui/button';
import { Clock } from 'lucide-react';

interface ExistingReflectionProps {
  existingReflection: string;
  setShowForm: (show: boolean) => void;
}

const ExistingReflection: React.FC<ExistingReflectionProps> = ({
  existingReflection,
  setShowForm,
}) => {
  return (
    <div className="space-y-4">
      <div className="bg-muted p-4 rounded-md">
        <div className="flex items-center mb-2">
          <Clock className="h-4 w-4 mr-2 text-muted-foreground" />
          <span className="text-sm text-muted-foreground">Submitted reflection</span>
        </div>
        <p className="whitespace-pre-wrap">{existingReflection}</p>
      </div>
      <Button
        variant="outline"
        onClick={() => setShowForm(true)}
      >
        Edit Reflection
      </Button>
    </div>
  );
};

export default ExistingReflection;
